import { Alert, Col, Flex, Spin, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useStores } from "stores";
import { USER_STATUS_ENUM } from "interfaces";
import { CustomButton, WhiteBoxBlock } from "ui";
import { ItemInfoBlock } from "components";
import { routes } from "constants/routes";
import { UserHeader } from "./UserHeader";
import { getColumns } from "./getColumns";
import { PasswordResetButton } from "./PasswordReset";
import { BlockUserButton } from "./BlockUser";
import { ActivateUserButton } from "./ActivateUser";
import { parseErrorMessage } from "utils";
import { getStatusMessage } from "services";
import { UserCompanyList } from "./UserCompanyList";

export const UserInfoPage = observer(() => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { userCard, user, userCompanyList } = useStores();

  const { isUserAdmin, isRiskManager, isOperator: isAnyOperator } = user.roles;

  useEffect(() => {
    if (id) {
      userCard.fetchCardById(id);
      userCompanyList.setId(id);
    }
  }, [id, userCard, userCompanyList]);

  const showUserBlockButton =
    (isUserAdmin || isRiskManager) &&
    (userCard.card.status === USER_STATUS_ENUM.ACTIVE || userCard.card.status === USER_STATUS_ENUM.DRAFT);

  const showUserActivateButton = (isUserAdmin || isRiskManager) && userCard.card.status === USER_STATUS_ENUM.BLOCKED;

  const showResetPasswordButton = userCard.card.status !== USER_STATUS_ENUM.BLOCKED;

  return (
    <Spin spinning={userCard.isPending}>
      {userCard.fetchStatus === "success" && (
        <Flex vertical gap="large">
          <UserHeader data={userCard.card} />
          <WhiteBoxBlock>
            <Flex vertical gap="large">
              <Typography.Text className="whitebox-title">Сведения о пользователе</Typography.Text>
              <ItemInfoBlock items={getColumns(userCard.card)} />
            </Flex>
          </WhiteBoxBlock>
          {isAnyOperator && <UserCompanyList />}
          <Flex gap="middle">
            {isUserAdmin && (
              <>
                <Col>
                  <CustomButton
                    onClick={() => {
                      navigate(`/${routes.users}/edit/${userCard.card.id}`);
                    }}
                  >
                    Редактировать
                  </CustomButton>
                </Col>
                {showResetPasswordButton && <PasswordResetButton />}
              </>
            )}
            {showUserBlockButton && <BlockUserButton />}
            {showUserActivateButton && <ActivateUserButton />}
          </Flex>
        </Flex>
      )}
      {userCard.fetchStatus === "error" && userCard.fetchError && (
        <Alert
          message={getStatusMessage(userCard.fetchError.status)}
          description={parseErrorMessage(userCard.fetchError)}
          type="error"
          showIcon
        />
      )}
    </Spin>
  );
});
